"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBtnsDataForAnotherElements = exports.listenPropChange = exports.initTextareaAutoheight = exports.DateFormatter = exports.focusElements = void 0;
exports.closest = closest;
exports.blockScrollBody = blockScrollBody;
exports.unblockScrollBody = unblockScrollBody;
exports.isEmailValid = isEmailValid;
exports.isUrlValid = isUrlValid;
exports.isPhoneValid = isPhoneValid;
exports.isPhoneValidUseIntl = isPhoneValidUseIntl;
exports.serializeToFormData = serializeToFormData;
exports.serializeToSearchString = serializeToSearchString;
exports.parseCommonResponseProperties = parseCommonResponseProperties;
exports.throttle = throttle;
exports.canScrollX = canScrollX;
exports.yieldToMain = yieldToMain;
exports.initializationsTasksWithYield = initializationsTasksWithYield;
exports.debounce = debounce;
exports.initAdditionalInfoToModalForm = initAdditionalInfoToModalForm;
exports.formatPrice = formatPrice;
exports.isIterable = isIterable;
exports.getUrl = getUrl;
/** Все css селекторы на которых может быть установлен фокус. */
exports.focusElements = [
    'a[href]',
    'area[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    'iframe',
    'object',
    'embed',
    '[contenteditable]',
    '[tabindex]:not([tabindex^="-"])',
];
/**
 * @version 2025-01-30_2
 *
 * @example
 * 	Создаст экземпляр на указанную дату
 * 	new DateFormatter('2024-12-11').toFormat("dd Mmm 'yy") - 11 Дек '24
 *
 * 	Создаст экземпляр на текущую дату
 * 	new DateFormatter()).toFormat("dd Mmm 'yy") - 30 Янв '25
 */
class DateFormatter {
    /** @param date - формат ISO 8601 */
    constructor(date = new Date()) {
        // Months:
        this.months = [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь',
        ];
        if (date) {
            this.date = new Date(date);
        }
        else {
            this.date = new Date();
        }
    }
    /**
     * @tests
     * 		const date = '2024-02-07';
     * 		[
     * 			"dd Mmm 'yy",
     * 			"dd mm 'yyyy",
     * 			'dd.mm.yyyy',
     * 			'd.mm.yyyy',
     * 			'd.m.yyyy',
     * 			"dd Mmm 'yyyyy",
     * 			'd.mmm.yyyy',
     * 			'd.mmmm.yyyy',
     * 			'ddd.mm.yyyy',
     * 		].forEach(format => {
     * 			console.warn(format + ' ---> ' + new DateFormatter(date).toFormat(format));
     * 		});
     */
    toFormat(format) {
        const dayNum = this.date.getDate();
        const monthIndex = this.date.getMonth();
        const yearNum = this.date.getFullYear();
        let formatRes = format;
        if (/\b(yyyy)\b(?!y)/.test(formatRes)) {
            /** yyyy -> 2025 */
            formatRes = formatRes.replace(/\b(yyyy)\b(?!y)/g, String(yearNum));
        }
        else if (/\b(yy)\b(?!y)/.test(formatRes)) {
            /** yy -> 25 */
            formatRes = formatRes.replace(/\b(yy)\b(?!y)/g, this.get_yy(yearNum));
        }
        else if (/(yyyyy)/.test(formatRes)) {
            console.warn('Должно быть максимум 4 символа "y"!');
        }
        if (/\b(Mmm)\b(?!m)/.test(formatRes)) {
            /** Mmm -> Янв */
            formatRes = formatRes.replace(/\b(Mmm)\b(?!m)/g, this.get_Mmm(monthIndex));
        }
        else if (/\b(mmm)\b(?!m)/.test(formatRes)) {
            /** mmm -> янв */
            formatRes = formatRes.replace(/\b(mmm)\b(?!m)/g, this.get_mmm(monthIndex));
        }
        else if (/\b(mm)\b(?!m)/.test(formatRes)) {
            /** mm -> 01 */
            const mm = this.addZeroBeforeOneNumber(monthIndex + 1);
            formatRes = formatRes.replace(/\b(mm)\b(?!m)/g, mm);
        }
        else if (/\b(m)\b(?!m)/.test(formatRes)) {
            /** m -> 1 */
            const m = String(monthIndex + 1);
            formatRes = formatRes.replace(/\b(m)\b(?!m)/g, m);
        }
        else if (/(mmmm)/.test(formatRes)) {
            console.warn('Должно быть максимум 3 символа "m"!');
        }
        if (/\b(dd)\b(?!d)/.test(formatRes)) {
            /** dd -> 07 */
            const dd = this.addZeroBeforeOneNumber(dayNum);
            formatRes = formatRes.replace(/\b(dd)\b(?!d)/g, dd);
        }
        else if (/\b(d)\b(?!d)/.test(formatRes)) {
            /** d -> 7 */
            formatRes = formatRes.replace(/\b(d)\b(?!d)/g, String(dayNum));
        }
        else if (/(ddd)/.test(formatRes)) {
            console.warn('Должно быть максимум 2 символа "d"!');
        }
        return formatRes;
    }
    // Statics:
    /** "2024-12-11" -> "11 Дек '24" */
    static toFormat_dd_Mmm_Qyy(dateString) {
        return new DateFormatter(dateString).toFormat("dd Mmm 'yy");
    }
    /** 2024-08-15 */
    static getDateCurrent() {
        return new Date().toISOString().slice(0, 10);
    }
    /** 1723604400 */
    static getTimestampSeconds() {
        return Math.floor(Date.now() / 1000);
    }
    /** 1724428867026 */
    static getTimestamp() {
        return Date.now();
    }
    // Tools:
    /** Добавляет ведущие нули. */
    addZeroBeforeOneNumber(num) {
        return num.toString().padStart(2, '0');
    }
    // Years:
    get_yy(yyyy) {
        return String(yyyy).slice(-2);
    }
    get_Mmm(monthIndex) {
        return this.months[monthIndex].slice(0, 3);
    }
    get_mmm(monthIndex) {
        let mmm = this.get_Mmm(monthIndex);
        return mmm.charAt(0).toLowerCase() + mmm.slice(1);
    }
}
exports.DateFormatter = DateFormatter;
/**
 * Находит родительский элемент по заданому селектору.
 *
 * @param $el - Элемент, чего родителя нужно найти.
 * @param selector - Селектор родителя, который необходимо найти.
 */
function closest($el, selector) {
    if ($el == null)
        return null;
    if (Element.prototype.closest) {
        return $el.closest(selector);
    }
    let parent = $el;
    while (parent) {
        if (parent.matches(selector)) {
            return parent;
        }
        parent = parent.parentElement;
    }
    return null;
}
/**
 * Включает блокировку скролла страницы
 *
 * Чтобы не прыгали html элементы с position: fixed - нужно добавить ему атрибут - data-fixed-position-elem
 */
function blockScrollBody() {
    const scrollPosition = window.pageYOffset;
    window.lastBlockScrollPosition = scrollPosition;
    const html = document.documentElement;
    const scrollbarWidth = window.innerWidth - html.clientWidth;
    html.style.top = `-${scrollPosition}px`;
    html.classList.add('html--block-scroll');
    if (scrollbarWidth > 0) {
        html.style.marginRight = `${scrollbarWidth}px`;
        const fixedElements = document.querySelectorAll('[data-fixed-position-elem]');
        fixedElements.forEach(element => {
            const el = element;
            const currentMarginRight = parseInt(getComputedStyle(el).marginRight) || 0;
            el.style.paddingRight = `${currentMarginRight + scrollbarWidth}px`;
        });
    }
}
function unblockScrollBody() {
    const html = document.documentElement;
    html.classList.remove('html--block-scroll');
    html.style.marginRight = '';
    html.style.top = '';
    const fixedElements = document.querySelectorAll('[data-fixed-position-elem]');
    fixedElements.forEach(element => {
        const el = element;
        el.style.paddingRight = '';
    });
    window.scrollTo(0, window.lastBlockScrollPosition || 0);
}
/** Проверяет является ли строка валидным адресом электронной почты. */
function isEmailValid(value) {
    return /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu.test(value);
}
/** Проверяет является ли строка валидным url. */
function isUrlValid(originalUrlString) {
    const urlString = /^https?:\/\//i.test(originalUrlString) ? originalUrlString : `http://${originalUrlString}`;
    try {
        new URL(urlString);
        return true;
    }
    catch (e) {
        return false;
    }
}
/** Проверяет является ли строка валидным номером телефона. */
function isPhoneValid(value) {
    const numbersArray = [];
    Array.from(value).forEach(char => {
        if (!!Number(char) || Number(char) === 0)
            numbersArray.push(char);
    });
    if (numbersArray.length < 11 || (numbersArray.length < 12 && value[1] === '+'))
        return false;
    return true;
}
/**
 * Проверяет является ли строка валидным номером телефона.
 *
 * При работе с библиотекой `intl`
 */
function isPhoneValidUseIntl($inputTel) {
    const isValid = $inputTel.intl.isValidNumber();
    return isValid;
}
/**
 * Кастомная сериализация формы в объект FormData.
 *
 * @param $element - DOM элемент для сериализации.
 */
function serializeToFormData($element) {
    const elements = $element.tagName === 'FORM'
        ? Array.from($element.elements)
        : Array.from($element.querySelectorAll('input, select, textarea, button'));
    const data = new FormData();
    elements.forEach(element => {
        if (!(element instanceof HTMLInputElement ||
            element instanceof HTMLSelectElement ||
            element instanceof HTMLTextAreaElement ||
            element instanceof HTMLButtonElement)) {
            return;
        }
        if (!element.name || element.hasAttribute('data-no-serialize')) {
            return;
        }
        const { name, type } = element;
        if (type === 'file') {
            if (element.getAttribute('multiple') === 'true') {
                const files = element.files;
                if (files) {
                    for (let i = 0; i < files.length; i++) {
                        // Добавляем каждый файл с уникальным ключом
                        data.append(`${name}[${i}]`, files[i]);
                    }
                }
            }
            else {
                const files = element.files;
                if (files && files[0])
                    data.append(name, files[0]);
            }
        }
        else {
            let value;
            if (type === 'tel') {
                value = element.value
                    .split(/[\s()-]/)
                    .join('')
                    .replace(/^8/, '+7');
            }
            else if (type === 'checkbox' || type === 'radio') {
                if (!element.checked)
                    return;
                value = element.value;
            }
            else if (type === 'date') {
                const format = element.getAttribute('data-date-format');
                value = format ? new DateFormatter(element.value).toFormat(format) : element.value;
            }
            else {
                value = element.value;
            }
            data.append(name, value);
        }
    });
    return data;
}
/** Сериализует форму в строку с параметрами. */
function serializeToSearchString($form) {
    const formData = serializeToFormData($form);
    const search = new URLSearchParams();
    // Преобразуем FormData в массив пар ключ-значение и добавляем их в URLSearchParams
    for (const [key, value] of formData.entries()) {
        search.append(key, value.toString());
    }
    const queryString = search.toString();
    return queryString;
}
/**
 * Функция для разбора общих свойств ответа.
 *
 * @param responseBody - Тело ответа от сервера.
 */
function parseCommonResponseProperties(responseBody) {
    if (Object.prototype.hasOwnProperty.call(responseBody, 'redirect-url')) {
        window.location.href = responseBody['redirect-url'];
    }
    if (Object.prototype.hasOwnProperty.call(responseBody, 'reload')) {
        if (responseBody.reload === true)
            window.location.reload();
    }
    if (Object.prototype.hasOwnProperty.call(responseBody, 'error-toast')) {
        const $formErrorToast = document.querySelector('[data-toast-name="formErrorToast"]');
        if ($formErrorToast) {
            const $toastText = $formErrorToast.querySelector('.toast__text');
            if ($toastText) {
                $toastText.textContent = responseBody['error-toast'];
                window.Toast.showToast('formErrorToast', {
                    removeAfterClose: false,
                });
            }
        }
    }
}
/**
 * Инициализирует автоподстраивающуюся высоту под текст внутри textarea.
 *
 * @param $textarea - Поле ввода типа textarea.
 */
const initTextareaAutoheight = ($textarea) => {
    $textarea.style.height = `${Math.max($textarea.offsetHeight, $textarea.scrollHeight)}px`;
    $textarea.classList.add('auto');
    $textarea.updateHeight = () => {
        $textarea.style.height = 'auto';
        $textarea.style.height = `${Math.max($textarea.scrollHeight, $textarea.offsetHeight)}px`;
    };
    $textarea.addEventListener('input', () => {
        var _a, _b;
        (_b = (_a = $textarea).updateHeight) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, { passive: true });
};
exports.initTextareaAutoheight = initTextareaAutoheight;
/**
 * Создаёт функцию с ограничением частоты вызова, которая вызывает предоставленную функцию не чаще одного раза за
 * указанный интервал времени.
 *
 * @example
 * 	// Функция, которая выводит текущее время
 * 	function printTime() {
 * 		console.log(new Date().toTimeString());
 * 	}
 *
 * 	// Создание функции с ограничением вызова, которая может быть вызвана не чаще чем раз в 1000 миллисекунд
 * 	const throttledPrintTime = throttle(printTime, 1000);
 *
 * 	// Вызов функции с ограничением вызова несколько раз подряд
 * 	setInterval(throttledPrintTime, 100);
 *
 * @param func - Функция, вызов которой необходимо ограничить.
 * @param limit - Интервал, в течение которого функция не будет повторно вызвана. (в миллисекундах)
 *
 * @returns Версия функции с ограничением вызова, которая при многократных вызовах будет выполнять исходную функцию не
 *   чаще, чем один раз за указанный интервал.
 */
function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function (...args) {
        const context = this;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        }
        else {
            clearTimeout(lastFunc);
            lastFunc = window.setTimeout(function () {
                if (Date.now() - lastRan >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}
/** Проверяет, имеет ли элемент горизонтальную прокрутку. */
function canScrollX($element) {
    return $element.scrollWidth > $element.clientWidth;
}
/** Функция для отдачи контроля основному потоку. */
function yieldToMain() {
    return new Promise(resolve => {
        setTimeout(resolve, 0);
    });
}
/**
 * Инициализирует задачи с использованием yield для основного потока.
 *
 * @param tasks - Массив функций задач.
 */
function initializationsTasksWithYield(tasks) {
    return __awaiter(this, void 0, void 0, function* () {
        while (tasks.length > 0) {
            const task = tasks.shift();
            if (task) {
                task();
                yield yieldToMain();
            }
        }
    });
}
/**
 * Выполнять колбэк только по прошествии указанного времени (с момента последнего вызова).
 *
 * @example
 * 	let setUnsetSwiperTouchMove = debounce(function (e) {
 * 		if (canScrollX($el)) {
 * 			disableSwiperTouchMove($el, swiper);
 * 		} else {
 * 			enableSwiperTouchMove($el, swiper);
 * 		}
 * 	}, 250);
 *
 * 	window.addEventListener('resize', setUnsetSwiperTouchMove);
 *
 * @param func - Функция, которую нужно отложить.
 * @param delay - Время откладывания (в миллисекундах).
 */
function debounce(func, delay) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(this, args);
        }, delay);
    };
}
/**
 * Добавляет информацию в скрытый `input[data-additional-input]`
 *
 * @param $btnFrom - Кнопка с атрибутом `data-additional-input="Информация в скрытый input"`
 * @param idModal
 */
function initAdditionalInfoToModalForm($btnFrom, idModal) {
    try {
        $btnFrom.addEventListener('click', function (e) {
            const $modalWithForm = document.getElementById(idModal);
            if ($modalWithForm) {
                const $inputAdditionalInfo = $modalWithForm.querySelector('[data-additional-input]');
                const additionalInfo = $btnFrom.dataset.additionalInfo;
                $inputAdditionalInfo.value = additionalInfo;
            }
            else {
                console.warn('Не задано модальное окно для открытия.');
            }
        });
    }
    catch (error) {
        console.error(error);
    }
}
/**
 * Форматирование числа в строку с пробелами на тысячных как принято в ru локали
 *
 * @example
 * 	console.log(formatPrice(12345)); \\ '12 345'
 */
function formatPrice(value) {
    return Intl.NumberFormat('ru', { style: 'decimal' }).format(value);
}
/** Проверяет является элемент иттерируемым или нет? */
function isIterable(obj) {
    return Symbol.iterator in Object(obj);
}
/**
 * Слушает изменения значения свойства в объекте и вызывает обработчик при изменении.
 *
 * @example
 * 	const user = {};
 * 	listenPropChange(user, 'age', (newAge, oldAge) => {
 * 		console.log(`Возраст изменился с ${oldAge} на ${newAge}`);
 * 	});
 *
 * 	user.age = 25; // Возраст изменился с undefined на 25
 * 	user.age = 30; // Возраст изменился с 25 на 30
 *
 * @param obj - Объект, свойство которого нужно отслеживать.
 * @param propName - Имя свойства, которое нужно отслеживать.
 * @param handler - Функция-обработчик, которая вызывается при изменении значения свойства. Принимает два аргумента:
 *   новое значение и старое значение свойства.
 */
const listenPropChange = (obj, propName, handler) => {
    /* Сохраняем текущее значение свойства */
    let _value = obj[propName];
    Object.defineProperty(obj, propName, {
        get() {
            return _value;
        },
        set(value) {
            /* Если значение не изменилось, не вызываем обработчик */
            if (value === _value)
                return;
            const old_value = _value;
            _value = value;
            handler(_value, old_value);
        },
        configurable: true,
        enumerable: true,
    });
};
exports.listenPropChange = listenPropChange;
/**
 * Инициализирует обработчики событий для кнопок с атрибутом `data-for-element`. Позволяет динамически изменять
 * содержимое или атрибуты других элементов на странице при клике.
 *
 * @example
 * 	```html
 * 	one obj <button data-hystmodal="#callbackModal" data-for-element='{"selector": "#callbackModal .form-additional-info", "text": "Кнопка \"Подобрать\"", "how": "value"}'>Подобрать</button>
 * 	array objs <button data-hystmodal="#callbackModal" data-for-element='[{"selector": "#callbackModal .form-additional-info", "text": "Кнопка \"Подобрать\"", "how": "value"}, {"selector": "#callbackModal .form-additional-info", "text": "Кнопка \"Подобрать\"", "how": "value"}]'>Подобрать</button>
 * 	```
 * 	При клике на кнопку элемент с селектором `#callbackModal .form-additional-info` получит атрибут `value` со значением "Кнопка \"Подобрать\"".
 *
 * @returns {void}
 */
const initBtnsDataForAnotherElements = () => {
    try {
        const elsBySelector = {};
        const btnsToModal = document.querySelectorAll('[data-for-element]');
        btnsToModal.forEach($btnToElement => {
            const handleClick = () => {
                const attr = $btnToElement.getAttribute('data-for-element');
                if (!attr)
                    return;
                let data;
                try {
                    data = JSON.parse(attr);
                }
                catch (e) {
                    console.warn('Некорректный JSON в data-for-element:', attr);
                    return;
                }
                if (!Array.isArray(data)) {
                    data = [data];
                }
                data.forEach(dataItem => {
                    if (!dataItem.selector || !dataItem.text || !dataItem.how) {
                        console.warn('Недостаточно данных в data-for-element:', dataItem);
                        return;
                    }
                    if (!elsBySelector[dataItem.selector]) {
                        const $el = document.querySelector(dataItem.selector);
                        if ($el) {
                            elsBySelector[dataItem.selector] = { $el, how: dataItem.how };
                        }
                    }
                    const elData = elsBySelector[dataItem.selector];
                    if (!elData)
                        return;
                    switch (elData.how) {
                        case 'textContent':
                            elData.$el.textContent = dataItem.text;
                            break;
                        default:
                            elData.$el.setAttribute(elData.how, dataItem.text);
                            break;
                    }
                });
            };
            $btnToElement.addEventListener('click', handleClick);
        });
    }
    catch (error) {
        console.error('Общая ошибка в initBtnsDataForAnotherElements:', error);
    }
};
exports.initBtnsDataForAnotherElements = initBtnsDataForAnotherElements;
/**
 * @example
 * 	if (!points) {
 * 		points = await getUrl(urlPoints);
 * 	}
 */
function getUrl(url) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!url) {
            console.log('url is not provided');
            return;
        }
        try {
            const response = yield fetch(url);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const result = yield response.json();
            return result;
        }
        catch (error) {
            console.error('Error fetching result:', error);
        }
    });
}
